<script setup>
import { storeToRefs } from "pinia";
import FeelingsWheel from "@/components/FeelingsWheel.vue";
import TrackDetails from "@/components/TrackDetails.vue";
import TracksList from "@/components/TracksList.vue";
import TheTour from "@/components/TheTour.vue";
import { useTrackStore } from "@/stores/TrackStore.js";
const { selectedTrack } = storeToRefs(useTrackStore());
</script>

<template>
  <main class="container-fluid mt-3">
    <div class="top row">
      <FeelingsWheel />
      <TrackDetails v-if="selectedTrack" :track="selectedTrack" />
      <TracksList v-else />
      <TheTour />
    </div>
  </main>
</template>
